<div class="profilePage">
    <div class="headerBg"></div>

    <div class="content">

        <div class="split">
            <div class="links">
                <div class="nameHolder">
                    <div class="name">
                        Hello, {{authService.profile?.firstName}}
                    </div>
                    <div class="nameLink">
                        <a (click)="logout()" class="logOut">Log Out</a>
                    </div>
                </div>

                <a [routerLink]="['/profile/wishlist']" routerLinkActive="router-link-active" class="link">
                    <div class="label">
                        My List
                    </div>
                </a>
                <a [routerLink]="['/profile/upcoming']" routerLinkActive="router-link-active" class="link">
                    <div class="label">
                        Upcoming Bookings
                    </div>
                </a>
                <a [routerLink]="['/profile/previous']" routerLinkActive="router-link-active" class="link">
                    <div class="label">
                        Previous Bookings
                    </div>
                </a>
                <a [routerLink]="['/profile/account']" routerLinkActive="router-link-active" class="link">
                    <div class="label">
                        Manage Account
                    </div>
                </a>
            </div>
    
            <div class="pageContent">
                <app-wish-list *ngIf="section == 'wishlist' "></app-wish-list>

                <app-upcoming *ngIf=" section == 'upcoming' "></app-upcoming>

                <app-previous *ngIf=" section == 'previous' "></app-previous>

                <app-manage *ngIf=" section == 'account' "></app-manage>
            </div>
        </div>
    </div>
</div>

<app-delete-overlay *ngIf="authService.deleteOverlayOpen"></app-delete-overlay>
